@if (section === 'titleMO') {
<div class="info-section">
  <div class="info">
    <span class="label">{{ 'building.summary.municipality' | transloco }}</span>
    <p class="subline">{{ building.municipality }}</p>
  </div>
  <div class="info">
    <span class="label">{{ 'building.summary.assignment' | transloco }}</span>
    @if (building.localizedAffectations?.length) {
    <p class="subline">
      {{ building.localizedAffectations | join }}
    </p>
    } @if (!building.localizedAffectations?.length) {
    <p class="subline">{{ 'building.affectationToDefine' | transloco }}</p>
    }
  </div>
  <div class="info">
    <span class="label">{{ 'building.summary.buildingClass' | transloco }}</span>
    <p class="subline">{{ building.buildingClass }}</p>
  </div>
  <div class="info">
    <span class="label">{{ 'building.summary.description' | transloco }}</span>
    <p class="subline">{{ building.description }}</p>
  </div>
  <div class="info">
    <span class="label">{{ 'building.summary.constructionPeriod' | transloco }}</span>
    @if (building.period) {
    <p class="subline">
      {{ 'building.constructionPeriod' | transloco : { period: building.period } }}
    </p>
    } @if (!building.period) {
    <p>&nbsp;</p>
    }
  </div>
  <div class="info">
    <span class="label">{{ 'building.summary.egid' | transloco }}</span>
    <p class="subline">
      {{ building.egids.join(' ') ?? ('common.notDefined' | transloco) }}
      @if ((canEditEgid$ | async) === true) {
      <mat-icon [title]="'common.edit' | transloco" (click)="editEgid()">edit</mat-icon>
      }
    </p>
  </div>
  <div class="info">
    <p class="label">
      {{ 'building.summary.complementaryInformations' | transloco }}
    </p>
  </div>
</div>
} @if (section === 'titleSibat') {
<div class="info-section">
  <div class="info">
    <span class="label">{{ 'building.summary.id' | transloco }}</span>
    <p class="subline">{{ building.id }}</p>
  </div>
  <div class="info">
    <span class="label">{{ 'building.summary.typology' | transloco }}</span>
    <p class="subline">
      <span class="color" [ngStyle]="{ color: getTextColor(building.typology?.color) }">
        {{ building.typology?.color || 'N/A' }}
      </span>
    </p>
  </div>
  @if (isBuildingStatusEnabled$ | async) {
  <div class="info">
    <span class="label">{{ 'building.summary.status' | transloco }}</span>
    <p class="subline">
      <span>
        @switch (building.status) { @case (buildingStatus.constructed) {
        <span class="subline">{{ 'building.status.constructed' | transloco }}</span>
        } @case (buildingStatus.exploitation) {
        <span class="subline">{{ 'building.status.exploitation' | transloco }}</span>
        } @case (buildingStatus.project) {
        <span class="subline">{{ 'building.status.project' | transloco }}</span>
        } @case (buildingStatus.underConstruction) {
        <span class="subline">{{ 'building.status.underConstruction' | transloco }}</span>
        } @case (buildingStatus.demolished) {
        <span class="subline">{{ 'building.status.demolished' | transloco }}</span>
        } }
      </span>
    </p>
  </div>
  }
  <div class="info">
    <span class="label">{{ 'building.summary.nextControlDate' | transloco }}</span>
    <p class="subline">
      {{ building.nextControlDate ? (building.nextControlDate | date : 'dd.MM.yyyy') : ('common.toBeDefined' | transloco) }}
      @if ((canEditNextControlDate$ | async) === true) {
      <mat-icon [title]="'common.edit' | transloco" (click)="editNextControlDate()">edit</mat-icon>
      }
    </p>
  </div>
  @if (!!building?.urlSharePoint) {
  <div class="info">
    <span class="label">{{ 'building.detail.sharePointLink' | transloco }}</span>
    <span class="subline">
      <sibat-link-button
        [href]="building.urlSharePoint"
        [external]="true"
        [target]="'_blank'"
        [label]="'building.detail.goToSharePoint' | transloco"
      ></sibat-link-button>
    </span>
  </div>
  }
</div>
}
